import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campMsdNew: FaireAdCampaignEntity = {
  token: "camp_msd_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_michelle_starbuck",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 500,
  startedRunningAt: "2026-09-01",
  segmentMetrics: {
    numCustomersAcquired: 16,
    salesDollars: 19585,
    totalAdsSpendDollars: 3432,
    cpaDollars: 214.5,
    bestEstimateSalesDollars: 15298,
    bestEstimateRoas: 4.46,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
